<form id="editor-form"
      [formGroup]="searchGroup">
    <div class="search-group">
        <div class="input-icon">
            <i class="fal fa-lg fa-search"
               aria-hidden="true">
            </i>
        </div>
        <div class="input-wrapper">
            <input type="text"
                   name="search"
                   formControlName="search"
                   class="input-field"
                   [ngClass]="(isNonEmpty | async)  ? 'non-empty' : ''"
                   id="searchFieldId"
                   #searchInput
                   [attr.value]="value"
                   autocomplete="off"
                   tabindex="0"
                   (focus)="onFocus"
                   (blur)="onBlur"/>
            <label class="search-label"
                   for="searchFieldId">{{'PLACEHOLDER.SEARCH' | translate}}
            </label>
        </div>
        <ng-container *ngIf="isSearchActivated | async as isSearchActivated">
            <div class="h4 show-results"
                 (click)="hideSearchResults()"
                 *ngIf="isPanelShown | async"
                 title="{{'LAYOUT.SEARCH.TOOLS.TITLE.HIDE' | translate}}">
                <aa-action-circle class="success duotone"
                                  [size]="'fa-sm'"
                                  [faIcon]="'fas fa-chevron-double-up'">
                </aa-action-circle>
            </div>
            <div class="h4 show-results"
                 (click)="showSearchResults()"
                 *ngIf="!(isPanelShown | async)"
                 title="{{'LAYOUT.SEARCH.TOOLS.TITLE.SHOW' | translate}}">
                <aa-action-circle class="success duotone"
                                  [size]="'fa-sm'"
                                  [faIcon]="'fas fa-chevron-double-down'">
                </aa-action-circle>
            </div>
            <div class="h4 clear-search"
                 (click)="clearSearchResults()">
                <aa-action-circle class="danger duotone"
                                  [size]="'fa-sm'"
                                  [faIcon]="'fas fa-times'">
                </aa-action-circle>
            </div>
        </ng-container>
    </div>
</form>
